import {Suspense, lazy, useEffect, useState} from 'react'
import "./About.styles.scss"
import heroImage from "../../assets/images/heroImage.jpeg"
import { ProgressCard } from '../progressCard/ProgressCard'
import gbc from "../../assets/images/george_brown_college_logo.jpg"
import ycet from "../../assets/images/ycet.png"
import st from "../../assets/images/st.jpg"

// Lazy load the parallax for performance
const ExtraCuricular = lazy(() => import('../ExtraCuricular/ExtraCuricular'));

export const About = () => {
  const [experience, setExperience] = useState([])
  useEffect(() => {
    const fetchExperience = async () => {
      const response = await fetch(
        "https://gist.githubusercontent.com/sourabkapoor/7feefdb53b62cdaa6fb96b65899d98e0/raw/gistfile1.txt"
      );
      const experienceData = await response.json();
      setExperience(experienceData);
    };
    fetchExperience();
  }, [])

  const education = [
    {
      logo: gbc,
      brand: "George Brown College",
      duration: "September 2023 - August 2024",
      degree: [
        "Post-Graduate Certificate in Cyber Security",
      ]
    },
    {
      logo: ycet,
      brand: "Yogananda College of Engineering and Technology",
      duration: "August 2016 - December 2020",
      degree: [
        "Bachelor's of Engineering in Computer Science",
      ]
    },
    {
      logo: st,
      brand: "St Xavier Convent School",
      duration: "August 2014 - May 2016",
    }
  ]

  return <div className='about'>
    <div className='sectionHeading'>Let me Introduce Myself...</div>
    {/* intro */}
    <div className='intro'>
      <div className='info'>
        I’m Sourab Kapoor, a self-taught Full Stack Developer who loves building cool stuff for the web (and occasionally breaking it while experimenting). With over 3+ years of experience, I’ve tackled different kinds of projects with some amazing teams, learning a ton along the way about what works—and what doesn’t.
        <br/>
        <br/>
        When I’m not coding with React, Node.js, Django, or Python (or trying to figure out why something isn’t working), you’ll probably find me planning my next trip or hunting for a great cup of coffee. I’m all about blending creativity with code and keeping things light while crafting apps that people actually enjoy using. Life’s too short for bad coffee and boring websites, right?
      </div>
      {/* Hero Image */}
      <img className='heroImage' src={heroImage} alt="..." fetchPriority="high"></img>
      {/* <div className='heroImage'></div> */}
    </div>

    {/* Skills */}
    {/* <div>
      <div className='sectionHeading'>What I bring to the table</div>
      
    </div> */}

    {/* experience */}
    {experience && 
      <div>
        <div className='sectionHeading mobileSection'>Experience</div>
        {experience.map((jobs, key) => {
          return <ProgressCard key={`expereice${key}`} {...jobs} />
        })}
      </div>
    }

    {/* Education */}
    <div>
      <div className='sectionHeading mobileSection'>Education</div>
      {education.map((edu, key) => {
        return <ProgressCard key={`eductaion${key}`} {...edu} />
      })}
    </div>

    {/* Extra curicular */}
    <div>
      <div className='sectionHeading mobileSection'>Because life’s not all about staring at a screen!</div>
      <Suspense>
        <ExtraCuricular />
      </Suspense>
    </div>
    
    {/* Things I enjoy doing */}
    <div>
      <div className='sectionHeading mobileSection'>Things I do out of curiosity and passion</div>
      {/* Teacher */}
      <div className="myCard">
        <img className='img' alt=".." src="https://2022.sommetnumerique.ca/fr/sponsors/download/logo/19" />
        <div className='infoSection'>
          <div className='heading'>Teacher</div>
          <span className='info'>
            I’m like a coding tour guide, helping people from all walks of life and every corner of the globe navigate the world of programming. Together, we turn ideas into dream projects—one line of code at a time. Wanna join the journey? Check out my profile&nbsp;
            <a target='_blank' href='https://www.superprof.co.uk/learn-web-development-with-personalized-lessons-from-html-css-and-javascript-advanced-frameworks-like-react-node-and-django.html' rel="noreferrer">here!</a>
          </span>
        </div>
      </div>
      {/* Freelancer */}
      <div className="myCard">
        <img className='img' alt=".." src="https://www.svgrepo.com/show/331630/upwork.svg" />
        <div className='infoSection'>
          <div className='heading'>Freelance Developer</div>
          <span className='info'>
            I’m also a freelancer who’s all about teaming up on quality projects and helping others bring their ideas to life. It’s a win-win—I get to learn new skills, stay inspired, and keep the creativity flowing!
          </span>
        </div>
      </div>
      {/* Reasearch paper writer */}
      <div className="myCard">
        <img className='img' alt=".." src="https://www.liveabout.com/thmb/5HTVKgTZBAPkmscR-ZiStaNeFMo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/writer2-172409300-58ae4fbb3df78c345b7c5b62.jpg" />
        <div className='infoSection'>
          <div className='heading'>Research Paper Writer</div>
          <span className='info'>
            I have writter a number of research paper and review papers. Some of my work are <span className='bold'>Pattern Recognition; Approaches and Applications</span>, <span className='bold'>Artificial Neural Networks; Latest Trends and Their Comparative Analysis</span> and <span className='bold'>Wireless Sensor Network</span>.
          </span>
        </div>
      </div>
      {/* Traveler */}
      <div className="myCard">
        <img className='img' alt=".." src="https://media.wired.com/photos/5a5f8e04578ad833ef6878da/master/w_2560%2Cc_limit/Away_Carry-On_TopArt.jpg" />
        <div className='infoSection'>
          <div className='heading'>Traveller</div>
          <span className='info'>
            And just in case you missed it—yes, I’m obsessed with traveling! It’s my ultimate brain detox and my excuse to explore new places, meet amazing people, and soak up all the adventures life throws at me. Got a trip in mind and need a travel buddy? Say no more—I’m already packing!
          </span>
        </div>
      </div>
    </div>
  </div>
}